import styled from 'styled-components';
import { Row, Button, Card, Tag, Tabs } from 'antd';
import { ThemeCard } from '../Styles/Theme';

// Main container - single card matching Figma
export const DetailContainer = styled.div`
  width: 100%;
  position: relative;
  background: linear-gradient(180deg, rgba(250, 249, 255, 0.5) 0%, #ffffff 100%);
  border: 1px solid #edeef3;
  border-radius: 16px;
  min-height: calc(100vh - 200px);
  overflow: hidden;
`;

// Header section with gradient background
export const HeaderSection = styled.div`
  background: ${({ theme }) => theme.settings.cardHeaderBg};
  border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 12px 12px 0 0;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height:60px;
  &.noBackground {
    background: ${({ theme }) => theme.settings.whiteColor};
  }
  @media (max-width: 768px) {
    display: inline-block;
    width: 100%;
  }
`;

// Content wrapper inside container
export const ContentWrapper = styled.div`
  padding:24px;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  
`;

export const BackButton = styled(Button)`
  background: #ffffff !important;
  border: 1px solid rgba(61, 41, 105, 0.2) !important;
  border-radius: 12px !important;
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  
  &:hover {
    background: #f5f5f5 !important;
    border-color: rgba(61, 41, 105, 0.3) !important;
  }
  
  svg {
    font-size: 16px;
    color: #0a1b39;
  }
`;

export const CampaignTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CampaignTitle = styled.h1`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.settings.primary};
  margin: 0;
`;

export const CampaignSubtitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.settings.tertiary};
  margin: 0;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  @media (max-width: 768px) {
    margin-top: 8px;
  }
`;

export const StatusBadge = styled.div`
  background: ${({ theme }) => theme.settings.whiteColor};
  border-radius: 20px;
  padding: 4px 12px;
  height: 24px;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0px 6px 29px rgba(89, 108, 148, 0.07), 0px 0.751293px 3.63125px rgba(89, 108, 148, 0.035);
  .status-icon {
    width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    svg {
      width: 14px;
      height: 14px;
    }
  }
  
  span {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: ${({ status }) => {
      switch(status) {
        case 'ready': return '#42abde';
        case 'live': 
        case 'in_progress': return '#48B569';
        case 'paused': return '#E5AA11';
        case 'closed':
        case 'completed': return '#83899F';
        case 'saved': return '#83899F';
        case 'published': return '#3d2969';
        default: return '#42abde';
      }
    }};
  }
`;

export const EditButton = styled(Button)`
  background: #ffffff !important;
  border: 1px solid rgba(61, 41, 105, 0.2) !important;
  border-radius: 8px !important;
  height: 48px !important;
  padding: 13px 16px !important;
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  
  &:hover {
    background: #f5f5f5 !important;
    border-color: rgba(61, 41, 105, 0.3) !important;
  }
  
  span {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    color: #3d2969;
  }
  
  svg {
    font-size: 14px;
    color: #3d2969;
  }
`;

export const PublishButton = styled(Button)`
  background: #3d2969 !important;
  border: 1px solid #3d2969 !important;
  border-radius: 12px !important;
  height: 48px !important;
  padding: 13px 16px !important;
  min-width: 124px !important;
  
  &:hover {
    background: #2a1b4b !important;
    border-color: #2a1b4b !important;
  }
  
  &:disabled {
    background: #d9d9d9 !important;
    border-color: #d9d9d9 !important;
    color: #ffffff !important;
  }
  
  span {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: #ffffff;
  }
`;

// Info card container - grid layout for the cards
export const InfoCardsRow = styled(Row)`
  margin-bottom: 20px;
`;

export const InfoCard = styled.div`
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 16px 20px;
  height: 80px;
  display: flex;
  align-items: center;
  gap: 22px;
`;

export const InfoIconWrapper = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #EDEBF1; 
  box-shadow: 0px 0.751px 3.631px rgba(89, 108, 148, 0.09), 0px 6px 29px rgba(89, 108, 148, 0.10);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  border: 2px solid ${({ theme }) => theme.settings.whiteColor};
  color: ${({ theme }) => theme.settings.primary} !important;

  filter: drop-shadow(0px 4px 4px rgba(204, 204, 204, 0.1)) !important;

  /* Force all child elements to be purple */
  * {
    color: ${({ theme }) => theme.settings.primary}  !important;
  }

  img {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }

  svg {
    width: 16px !important;
    height: 16px !important;
    color: ${({ theme }) => theme.settings.primary} !important;
    fill: ${({ theme }) => theme.settings.primary} !important;
  }

  /* Target all SVG paths to ensure fill color */
  svg path {
    fill: #3d2969 !important;
  }

  /* Target Ant Design icon specifically */
  .anticon {
    color: #3d2969 !important;
    font-size: 16px !important;

    svg {
      color: #3d2969 !important;
      fill: #3d2969 !important;
    }
  }
`;

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

export const InfoLabel = styled.span`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  color: ${({ theme }) => theme.settings.tertiary};
`;

export const InfoValue = styled.span`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  color: ${({ theme }) => theme.settings.primary};
  a {
    color: ${({ theme }) => theme.settings.primary};
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

// Divider line matching Figma
export const SectionDivider = styled.div`
  width: 100%;
  height: 0;
  border: none;
  border-bottom: 1px solid #edeef3;
  margin: 8px 0 24px 0;
`;

// Section for PureSpectrum Integration
export const IntegrationSection = styled.div`
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
`;

export const SectionTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.settings.primary};
  margin: 0 0 16px 0;
`;

// Survey Message Section
export const SurveyMessageSection = styled.div`
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 10px;
  padding: 16px;
`;

export const SurveyMessageContent = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 14px;
  line-height: 1.6;
  background: ${({ theme }) => theme.settings.whiteColor};
  color: ${({ theme }) => theme.settings.primary};
  border-radius: 10px;
  padding: 16px;
  
  p {
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  ul, ol {
    margin-bottom: 12px;
    padding-left: 20px;
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
`;

// Loading state
export const LoadingCard = styled(ThemeCard)`
  margin-bottom: 24px;
  text-align: center;
  padding: 40px;
`;

// Action buttons row at the bottom
export const ActionButtonsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
`;

export const ActionButton = styled(Button)`
  border-radius: 8px !important;
  height: 40px !important;
  padding: 8px 16px !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  font-family: 'Montserrat', sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  
  &.primary {
    background: #3d2969 !important;
    border: 1px solid #3d2969 !important;
    color: #ffffff !important;
    
    &:hover {
      background: #2a1b4b !important;
      border-color: #2a1b4b !important;
    }
  }
  
  &.secondary {
    background: #ffffff !important;
    border: 1px solid rgba(61, 41, 105, 0.2) !important;
    color: #3d2969 !important;
    
    &:hover {
      background: #f5f5f5 !important;
      border-color: rgba(61, 41, 105, 0.3) !important;
    }
  }
  
  &.danger {
    background: #ffffff !important;
    border: 1px solid #ff4d4f !important;
    color: #ff4d4f !important;
    
    &:hover {
      background: #fff1f0 !important;
      border-color: #ff7875 !important;
    }
  }
`;

// Legacy styled components for backward compatibility
export const DetailCard = styled(ThemeCard)`
  margin-bottom: 24px;
  position: relative;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const TitleWrapper = styled.div``;

export const DetailFieldWrapper = styled.div``;

export const DetailLabel = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #1f2430;
  margin-bottom: 4px;
`;

export const DetailValue = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #0a1b39;
`;

export const DemographicsSection = styled(Row)`
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
`;

export const TableTitle = styled.h3`
  margin-bottom: 16px;
`;

export const PureSpectrumCard = styled.div`
  width: 100%;
  position: relative;
  background: rgba(27, 136, 68, 0.05);
  border: 1px solid rgba(27, 136, 68, 0.2);
  border-radius: 10px;
  padding: 10px 16px;
  h3{
    font-family: ${({ theme }) => theme.fonts.inter};
    margin: 0px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${({ theme }) => theme.settings.tertiary};
  }
  p{
    font-family: ${({ theme }) => theme.fonts.inter};
    margin: 0px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: rgba(31, 36, 48, 0.5);
  }
  /* &.smallPadding{
    .ant-card-body {
      padding: 10px !important;
    }
    h5{
      font-family: ${({ theme }) => theme.fonts.inter};
      margin: 0px;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      color: #1B8844;
      img{
      float: left;
      margin-right: 8px;  
      }
    }
  } */
`;
export const HeaderInfoCard = styled(Card)`
  width: 100%;
  position: relative;
  height: 100%;
  .ant-card-head {
    padding: 16px !important;
    background: rgba(243, 244, 246, 0.5);
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${({ theme }) => theme.settings.primary};
    span.required{
      color: ${({ theme }) => theme.settings.orangeColor};
      font-size: 14px;
      font-weight: 500;
      margin-left: 4px;
    }
  }
  .refresh-btn {
    width: 28px !important;
    height: 28px !important;
    min-width: 28px !important;
    padding: 0 !important;
    border-radius: 8px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    .anticon {
      font-size: 12px;
    }
  }
  .ant-card-body {
    padding: 16px !important;
  }
  /* Table card variant - no body padding for full-width tables */
  &.tableCard {
    .ant-card-body {
      padding: 0 !important;
    }
    .ant-table {
      border-radius: 0 0 8px 8px;
    }
    .ant-pagination {
      padding: 12px 16px;
      margin: 0;
    }
  }
  .justifyBetween{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .title{
      font-family: ${({ theme }) => theme.fonts.inter};
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: ${({ theme }) => theme.settings.secondary};
    }
    .value{
      font-family: ${({ theme }) => theme.fonts.inter};
      color: #0a1b39;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      text-align: right;
      a{
        color: #0a1b39;
        &:hover {
          color: ${({ theme }) => theme.settings.primary} !important;
        }
      }
    }
  }
`;
export const TargetAudienceCard = styled(Card)`
  width: 100%;
  position: relative;
  border: none;
  background: transparent;
  box-shadow: none;
.ant-card-body {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 0px !important;
  .leftIcon{
    position: relative;
    width: 50px;
    height:50px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${({ theme }) => theme.settings.borderColor};
    box-shadow: 0px 0px 8px rgba(50, 50, 50, 0.05);
    border-radius: 10px;
    &.background{
      background: ${({ theme }) => theme.settings.qstTitleColor};
      border-radius: 10px;
      padding: 16px;
    }
  }
  .rightContent{
    position: relative;
    flex: 1;
    min-width: 0;
    .value{
      font-family: ${({ theme }) => theme.fonts.inter};
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: ${({ theme }) => theme.settings.tertiary};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
`;
export const SyncStatusTag = styled(Tag)`
  border-radius: 6px;
  padding: 4px 10px !important;
  margin: 0 !important;
  height: auto !important;
  display: inline-flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  gap: 4px;

  .anticon {
    font-size: 12px;
  }
`;

// Email Invite Card - Same style as PureSpectrum Card (green theme)
export const EmailInviteCard = styled.div`
  width: 100%;
  position: relative;
  background: rgba(27, 136, 68, 0.05);
  border: 1px solid rgba(27, 136, 68, 0.2);
  border-radius: 10px;
  padding: 10px 16px;
  h3 {
    font-family: ${({ theme }) => theme.fonts.inter};
    margin: 0px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${({ theme }) => theme.settings.tertiary};
  }
  p {
    font-family: ${({ theme }) => theme.fonts.inter};
    margin: 0px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: rgba(31, 36, 48, 0.5);
  }
`;

// Small Info Card for compact display
export const SmallInfoCard = styled.div`
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 10px;
  padding: 12px 16px;

  .card-title {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.settings.tertiary};
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .card-content {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    color: ${({ theme }) => theme.settings.primary};
    line-height: 1.5;
  }
`;

// Quota Performance Section
export const QuotaFieldCard = styled.div`
  border: 1px solid #E2E8EE;
  border-radius: 10px;
  overflow: hidden;
  height: 100%;

  .field-card-header {
    display: grid;
    grid-template-columns: 1fr 100px 55px 55px 70px;
    align-items: center;
    padding: 8px 14px;
    background: #FAFBFC;
    border-bottom: 1px solid #E2E8EE;
    gap: 6px;

    .field-name {
      font-family: ${({ theme }) => theme.fonts.inter};
      font-size: 13px;
      font-weight: 600;
      color: ${({ theme }) => theme.settings.primary};
    }

    .col-header {
      font-family: ${({ theme }) => theme.fonts.inter};
      font-size: 10px;
      font-weight: 600;
      color: ${({ theme }) => theme.settings.tertiary};
      text-transform: uppercase;
      letter-spacing: 0.3px;
      text-align: center;
      line-height: 1.2;
    }
  }

  .field-card-body {
    padding: 0;
  }

  &.interlocked {
    .field-card-header {
      grid-template-columns: 1fr 120px 65px 65px 90px;
    }

    .field-card-body {
      max-height: 400px;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background: #d9d9d9;
        border-radius: 4px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
    }
  }
`;

export const QuotaRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 100px 55px 55px 70px;
  align-items: center;
  padding: 8px 14px;
  gap: 6px;
  border-bottom: 1px solid #f5f5f5;
  transition: background 0.15s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: rgba(61, 41, 105, 0.02);
  }

  .row-label {
    min-width: 0;
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.settings.primary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .row-fielded-goal {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 13px;
    text-align: center;

    .fielded {
      font-weight: 600;
      color: ${({ theme }) => theme.settings.primary};
    }

    .separator {
      color: ${({ theme }) => theme.settings.tertiary};
      margin: 0 2px;
    }

    .goal {
      font-weight: 400;
      color: ${({ theme }) => theme.settings.tertiary};
    }
  }

  .row-target {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.settings.primary};
    text-align: center;
  }

  .row-currently-open {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.settings.tertiary};
    text-align: center;
  }

  .row-progress {
    flex-shrink: 0;
    width: 60px;
  }

  .interlocked & {
    grid-template-columns: 1fr 120px 65px 65px 90px;

    .row-progress {
      width: 80px;
    }
  }
`;

// Health Checks Section
// Health Checks — uses HeaderInfoCard.tableCard for edge-to-edge rows
export const HealthCheckHeader = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr 0.6fr 1.8fr 1.8fr;
  align-items: center;
  padding: 10px 24px;
  border-bottom: 2px solid ${({ theme }) => theme.settings.borderColor};
  gap: 24px;
  position: sticky;
  top: 0;
  z-index: 1;
  background: ${({ theme }) => theme.settings.whiteColor};

  span {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 11px;
    font-weight: 700;
    color: ${({ theme }) => theme.settings.secondary};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`;

export const HealthCheckRow = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr 0.6fr 1.8fr 1.8fr;
  align-items: center;
  padding: 14px 24px;
  gap: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor};

  &:last-child {
    border-bottom: none;
  }

  .metric-name {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.settings.primary};
  }

  .status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.2px;
    white-space: nowrap;

    .status-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      flex-shrink: 0;
    }

    &.green {
      color: #00A63E;
      .status-dot { background: #00A63E; }
    }
    &.red {
      color: #FF4D4F;
      .status-dot { background: #FF4D4F; }
    }
    &.yellow {
      color: #FAAD14;
      .status-dot { background: #FAAD14; }
    }
    &.grey {
      color: #8C8C8C;
      .status-dot { background: #8C8C8C; }
    }
  }

  .metric-value {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.settings.primary};
  }

  .reason-text {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.settings.secondary};
    line-height: 1.5;
  }

  .recommendation-text {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.settings.secondary};
    line-height: 1.5;
  }

  .no-recommendation {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 13px;
    color: #D9D9D9;
  }
`;

export const PsStatsTabs = styled(Tabs)`
  background: ${({ theme }) => theme.settings.whiteColor};
  border-radius: 10px;
  border: 1px solid #f0f0f0;

  .ant-tabs-nav {
    margin: 0 !important;
    padding: 14px 16px 0 0;

    &::before {
      border-bottom: 1px solid #f0f0f0;
    }
  }

  .ant-tabs-tab {
    background: #f0f0f0 !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 16px !important;

    &:hover {
      background: ${({ theme }) => theme.settings.gradientBg} !important;
      .ant-tabs-tab-btn {
        color: ${({ theme }) => theme.settings.whiteColor} !important;
      }
    }
  }

  .ant-tabs-tab-active {
    background: ${({ theme }) => theme.settings.gradientBg} !important;
    .ant-tabs-tab-btn {
      color: ${({ theme }) => theme.settings.whiteColor} !important;
    }
  }

  .ant-tabs-extra-content {
    align-self: center;
    margin-bottom: 10px;
  }
`;

// Scrollable content wrapper with proper scrollbar styling
export const ScrollableContent = styled.div`
  max-height: ${({ maxHeight }) => maxHeight || '60vh'};
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.settings.borderColor};
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.settings.primary};
  }
  &::-webkit-scrollbar-corner {
    background: ${({ theme }) => theme.settings.borderColor};
  }
`;